<div class="container-fluid">
  <app-custom-table-title [icon]="icon" [title]="title" [subTitle]="subTitle"></app-custom-table-title>
  <div class="mt-4 mb-4 cf-table-card">
    <ng-template #invoiceSummary let-data="data">
      <div class="total-card" style="display: inline-block;">
        <p class="label" style="margin: 0!important;">Base: <strong>{{ (summary?.totalBase || 0) | number:'1.2-2' }} €</strong></p>
      </div>
      <div class="total-card" style="display: inline-block;">
        <p class="label" style="margin: 0!important;">Total: <strong>{{ (summary?.total || 0) | number:'1.2-2' }} €</strong></p>
      </div>
    </ng-template>

    <ng-template #quickFilter>
      <div class="quick-filter">
        <app-months-filter [control]="monthsControl"></app-months-filter>

        <app-search-filter [value]="quickSearch" (searchChange)="onSearchChange($event)"></app-search-filter>
      </div>
    </ng-template>

    <app-custom-table #table="customTable" [config]="tableConfig"></app-custom-table>

    <ng-template #expandDetail let-row>
      <app-document-detail-tabs [row]="row" [detailLoader]="detailLoader" [showNotes]="false"></app-document-detail-tabs>
    </ng-template>
  </div>
</div>
